<div class="user-profile-container">
  @if (isNewUser) {
  <h1>{{ 'user.create_user' | translate }}</h1>
  } @if (!isNewUser) {
  <h1>{{ 'user.edit_user' | translate }}</h1>
  }
  <stx-user-personal-data [userData]="user"></stx-user-personal-data>
  <h4>{{ 'profile' | translate }}</h4>
  @if (user && isProfileReadonly) { @for (profile of user.profiles; track profile) {
  <div class="profile-container m-b-24 flex-row-container">
    <div class="roles">{{ profile.role.name }}</div>
    <div class="flex-row-container" [ngClass]="{ 'no-profile-name': !(profile && profile.name), scopes: profile && profile.name }">
      @if (profile && profile.name) {
      <div class="flex-column-container">
        <div class="profile-name-label">Profile Name</div>
        <div class="profile-name">{{ profile.name }}</div>
      </div>
      }
      <div class="profile-actions flex-row-container">
        <mat-icon class="m-r-20" (click)="editProfile(profile)">create</mat-icon>
        @if (showDeleteIcon) {
        <mat-icon (click)="deleteProfile(profile)">delete</mat-icon>
        }
      </div>
    </div>
  </div>
  }
  <div class="button-position m-t-24 m-b-35">
    <button data-testid="button-user-page" mat-stroked-button color="primary" class="send-link-button" (click)="addProfile()">
      {{ 'user.add_profile' | translate }}
    </button>
  </div>
  } @else {
  <stx-user-profile [profile]="selectedProfile" [isEditingExistingProfile]="isEditingExistingProfile"></stx-user-profile>
  }
  <mat-divider></mat-divider>
  <stx-action-buttons
    [primaryText]="isNewUser ? ('user.add_user' | translate) : ('submit' | translate)"
    [secondaryText]="'user.send_link_save' | translate"
    [asyncSecondaryAction]="initiateSave(true)"
    [asyncPrimaryAction]="initiateSave()"
  ></stx-action-buttons>
  @if (errorKeys.length > 0) {
  <div class="errors flex-column-container">
    @for (error of errorKeys; track error) {
    <mat-error>{{ error | translate }}</mat-error>
    }
  </div>
  }
</div>
